import * as api from './api'
import { getHQCenterId, getSelectedCenter } from '../centers/reducers'
import { errorHandler } from '../api'
import { STONES_FAMILIES } from '../../components/natural-stone/NaturalStoneHelper'
import { getLanguage } from '../ui/reducers'

export const fetchBannerProducts = () => (dispatch, getState) => {
    const state = getState()
    // const centerId = getSelectedCenter(state)
    const centerId = getHQCenterId(state)
    const lang = getLanguage(state)
    dispatch({ type: 'FETCH_PN_BANNER_PRODUCTS_REQUEST' })
    
    return api.fetchBannerProducts(centerId, lang)
    .then(response => {
        dispatch({ type: 'FETCH_PN_BANNER_PRODUCTS_SUCCESS', payload: response.data.headerSlabs })
    })
    .catch(error => {
        dispatch({ type: 'FETCH_PN_BANNER_PRODUCTS_FAILURE' })
        errorHandler(dispatch, error.response)
    })
}

export const fetchPerfectSlabs = (family) => (dispatch, getState) => {

    // const centerId = getSelectedCenter(getState()
    const centerId = getHQCenterId(getState())
    dispatch({ type: 'FETCH_PN_PERFECT_SLABS_REQUEST' })

    return api.fetchPerfectSlabs(centerId, STONES_FAMILIES[family].toLowerCase())
        .then(response => {
            dispatch({ type: 'FETCH_PN_PERFECT_SLABS_SUCCESS', payload: {[family]:response.data.perfectSlabs } })
        })
        .catch(error => {
            dispatch({ type: 'FETCH_PN_PERFECT_SLABS_FAILURE' })
            errorHandler(dispatch, error.response)
        })
}

export const fetchNewest = () => (dispatch, getState) => {
    // const centerId = getSelectedCenter(getState()
    const centerId = getHQCenterId(getState())
    dispatch({ type: 'FETCH_PN_NEWEST_REQUEST' })

    return api.fetchNewest(centerId)
        .then(response => {
            dispatch({ type: 'FETCH_PN_NEWEST_SUCCESS', payload: response.data.newestColors })
        })
        .catch(error => {
            dispatch({ type: 'FETCH_PN_NEWEST_FAILURE' })
            errorHandler(dispatch, error.response)
        })
}

export const fetchOutlet = () => (dispatch, getState) => {
    // const centerId = getSelectedCenter(getState()
    const centerId = getHQCenterId(getState())
    dispatch({ type: 'FETCH_PN_OUTLET_REQUEST' })

    return api.fetchOutlet(centerId)
        .then(response => {
            dispatch({ type: 'FETCH_PN_OUTLET_SUCCESS', payload: response.data.outletProducts })
        })
        .catch(error => {
            dispatch({ type: 'FETCH_PN_OUTLET_FAILURE' })
            errorHandler(dispatch, error.response)
        })
}